import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'lib-flexible';
import './plugins/rem.js'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.use(Vant);
Vue.config.productionTip = false

Vue.prototype.$video = Video

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
